// QA/Test environment configuration
export const environment = {
  production: false,
  apiUrl: 'https://qaapi.statementgames.com/',
  logoUploadUrL: 'https://qaapi.statementgames.com/',
  fileUploadUrL: 'https://qaapi.statementgames.com/',
  // QA specific settings
  debug: true,
  enableLogging: true,
};
